import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';

export const useCertificateList = (params?: any) => {
  return useQuery({
    queryKey: ['certificate-list', params],
    queryFn: async () => {
      const res = await request.get('/course-certificate', { params });
      return res.data;
    }
  });
};
